// On a phone, sign-in leaves for Google in the same tab. A reader stopped by the sign-up wall mid-story
// comes back to that story with their typed line, and a returning sign-in is finished by the auth provider.
const WALL = "signupWall";
const RETURN = "signupReturn";
const CLAIMED = "claimedStory";
const TEXT = "restoreText";
const REDIRECTING = "authRedirecting";

function storage() {
    try {
        return window.sessionStorage;
    } catch (e) {
        return null;
    }
}

function readJson(key) {
    try {
        return JSON.parse(storage()?.getItem(key) || "null");
    } catch (e) {
        return null;
    }
}

export function rememberWall(storyId, text) {
    if (storyId) storage()?.setItem(WALL, JSON.stringify({storyId, text}));
}

export function forgetWall() {
    storage()?.removeItem(WALL);
}

// Called just before leaving for Google
export function armReturn(providerName) {
    const s = storage();
    if (!s) return;
    s.setItem(REDIRECTING, providerName);
    const wall = s.getItem(WALL);
    if (wall) {
        s.setItem(RETURN, wall);
        s.removeItem(WALL);
    }
}

// The provider name if this page load is the way back from Google, once
export function takeRedirecting() {
    const s = storage();
    const name = s?.getItem(REDIRECTING);
    if (name) s.removeItem(REDIRECTING);
    return name || null;
}

// The story to go back to after a sign-in that started at the wall, once
export function takeReturn() {
    const ret = readJson(RETURN);
    const s = storage();
    if (!s || !ret) return null;
    s.removeItem(RETURN);
    s.setItem(CLAIMED, ret.storyId);
    if (ret.text) s.setItem(TEXT, JSON.stringify({storyId: ret.storyId, text: ret.text}));
    return ret.storyId;
}

// An anonymous story the reader just signed up from: theirs to keep writing (the next part saves it to their account)
export function isClaimed(storyId) {
    return !!storyId && storage()?.getItem(CLAIMED) === storyId;
}

// The line typed at the wall, once, only on the story it was typed into
export function takeRestoredText(storyId) {
    const saved = readJson(TEXT);
    if (!saved || !storyId || saved.storyId !== storyId) return "";
    storage()?.removeItem(TEXT);
    return saved.text || "";
}

// Leaving for Google failed: the wall's story stays remembered for another try
export function disarmReturn() {
    const s = storage();
    if (!s) return;
    const ret = s.getItem(RETURN);
    if (ret) s.setItem(WALL, ret);
    s.removeItem(RETURN);
    s.removeItem(REDIRECTING);
}
